import { Address } from '@/types/address'

/**
 * Concatenates address components into a formatted string
 * @param address - Address object with optional address components
 * @returns Formatted address string with components joined by commas
 */
export const concatenateAddress = (
  address: Address | null | undefined,
): string => {
  if (!address) return ''

  const addressComponents = [
    address.address_line_1,
    address.address_line_2,
    address.city,
    address.state_abv,
    address.postal_code,
  ]
    .filter(Boolean)
    .join(', ')

  return addressComponents
}
